// .intro スライダー -----
$(".intro__list")
	.on("init", function () {
		matchIntroDescHeight();
		$(this).addClass("is-ready");
	})
	.slick({
		autoplay: true,
		autoplaySpeed: 3000,
		arrows: false,
		dots: true,
		pauseOnFocus: true,
		pauseOnHover: true,
		pauseOnDotsHover: false,
		slidesToShow: 3,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 2,
				},
			},
			{
				breakpoint: 769,
				settings: {
					slidesToShow: 1,
					variableWidth: true,
				},
			},
		],
	});

// .intro__item-desc 高さ -----
function matchIntroDescHeight() {
	let maxHeight = 0;

	const items = document.querySelectorAll(".intro__item-desc");

	items.forEach((el) => {
		el.style.height = "auto";
		maxHeight = Math.max(maxHeight, el.offsetHeight);
	});

	items.forEach((el) => {
		el.style.height = maxHeight + "px";
	});
}

$(window).on("resize", function () {
	matchIntroDescHeight();
});

// .voice スライダー -----
$(".voice__list")
	.on("init", function () {
		matchVoiceHeight();
		$(this).addClass("is-ready");
	})
	.slick({
		autoplay: true,
		autoplaySpeed: 3000,
		arrows: false,
		dots: true,
		pauseOnFocus: true,
		pauseOnHover: true,
		pauseOnDotsHover: false,
		slidesToShow: 3,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 2,
				},
			},
			{
				breakpoint: 769,
				settings: {
					centerMode: true,
					centerPadding: "6%",
					slidesToShow: 1,
				},
			},
		],
	});

// .voice内 高さ -----
function matchHeight(selector) {
	let maxHeight = 0;

	const items = document.querySelectorAll(selector);

	items.forEach((el) => {
		el.style.height = "auto";
		maxHeight = Math.max(maxHeight, el.offsetHeight);
	});

	items.forEach((el) => {
		el.style.height = maxHeight + "px";
	});
}

function matchVoiceHeight() {
	matchHeight(".voice__txt");
	matchHeight(".voice__career--before");
	matchHeight(".voice__career--after");
}

$(window).on("resize", function () {
	matchVoiceHeight();
});

// .advisor SP時開閉 -----
document.addEventListener("DOMContentLoaded", () => {
	const mq = window.matchMedia("(max-width: 768px)");
	const moreBtn = document.querySelector(".advisor__more");
	const cont = document.querySelector(".advisor__cont");
	const moreTxt = document.querySelector(".advisor__more-txt");

	if (!moreBtn || !cont || !moreTxt) return;

	const CLOSED_HEIGHT = 210;
	let isAnimating = false;

	const setClosedState = () => {
		cont.style.height = `${CLOSED_HEIGHT}px`;
		cont.classList.remove("is-open");
		cont.classList.remove("is-before-hidden");
		moreBtn.classList.remove("is-open");
		moreBtn.setAttribute("aria-expanded", "false");
		moreTxt.textContent = "詳しく見る";
	};

	const setOpenState = () => {
		cont.classList.add("is-open");
		cont.classList.add("is-before-hidden");
		moreBtn.classList.add("is-open");
		moreBtn.setAttribute("aria-expanded", "true");
		moreTxt.textContent = "閉じる";
	};

	const openAdvisor = () => {
		if (isAnimating) return;
		isAnimating = true;

		setOpenState();

		cont.style.height = `${CLOSED_HEIGHT}px`;
		const targetHeight = cont.scrollHeight;

		requestAnimationFrame(() => {
			cont.style.height = `${targetHeight}px`;
		});

		const onEnd = (e) => {
			if (e.propertyName !== "height") return;
			cont.removeEventListener("transitionend", onEnd);

			cont.style.height = "auto";
			isAnimating = false;
		};

		cont.addEventListener("transitionend", onEnd);
	};

	const closeAdvisor = () => {
		if (isAnimating) return;
		isAnimating = true;

		const currentHeight = cont.scrollHeight;
		cont.style.height = `${currentHeight}px`;

		// 閉じるを押した瞬間に before を戻す
		cont.classList.remove("is-before-hidden");

		requestAnimationFrame(() => {
			cont.style.height = `${CLOSED_HEIGHT}px`;
		});

		moreBtn.classList.remove("is-open");
		moreBtn.setAttribute("aria-expanded", "false");
		moreTxt.textContent = "詳しく見る";

		const onEnd = (e) => {
			if (e.propertyName !== "height") return;
			cont.removeEventListener("transitionend", onEnd);

			cont.classList.remove("is-open");
			isAnimating = false;
		};

		cont.addEventListener("transitionend", onEnd);
	};

	const resetAdvisor = () => {
		if (mq.matches) {
			setClosedState();
		} else {
			cont.style.height = "auto";
			cont.classList.remove("is-open");
			cont.classList.remove("is-before-hidden");
			moreBtn.classList.remove("is-open");
			moreBtn.setAttribute("aria-expanded", "false");
			moreTxt.textContent = "詳しく見る";
		}
	};

	moreBtn.addEventListener("click", () => {
		if (!mq.matches || isAnimating) return;

		if (cont.classList.contains("is-open")) {
			closeAdvisor();
		} else {
			openAdvisor();
		}
	});

	resetAdvisor();
	window.addEventListener("resize", resetAdvisor);
});

// .faq アコーディオン
document.addEventListener("DOMContentLoaded", () => {
	const faqItems = document.querySelectorAll(".faq__item");

	faqItems.forEach((item, index) => {
		const head = item.querySelector(".faq__head");
		const cont = item.querySelector(".faq__cont");

		if (!head || !cont) return;

		const contentId = `faq-content-${index + 1}`;
		head.setAttribute("aria-expanded", "false");
		head.setAttribute("aria-controls", contentId);
		cont.setAttribute("id", contentId);
		cont.hidden = true;
		cont.style.height = "0px";
		cont.style.overflow = "hidden";

		let isAnimating = false;

		const openFaq = () => {
			if (isAnimating) return;
			isAnimating = true;

			item.classList.add("is-open");
			cont.hidden = false;
			head.setAttribute("aria-expanded", "true");

			cont.style.height = "0px";
			const targetHeight = cont.scrollHeight;

			requestAnimationFrame(() => {
				cont.style.height = `${targetHeight}px`;
			});

			const onEnd = (e) => {
				if (e.propertyName !== "height") return;
				cont.removeEventListener("transitionend", onEnd);

				cont.style.height = "auto";
				isAnimating = false;
			};

			cont.addEventListener("transitionend", onEnd);
		};

		const closeFaq = () => {
			if (isAnimating) return;
			isAnimating = true;

			cont.style.height = `${cont.scrollHeight}px`;

			requestAnimationFrame(() => {
				item.classList.remove("is-open");
				head.setAttribute("aria-expanded", "false");
				cont.style.height = "0px";
			});

			const onEnd = (e) => {
				if (e.propertyName !== "height") return;
				cont.removeEventListener("transitionend", onEnd);

				cont.hidden = true;
				isAnimating = false;
			};

			cont.addEventListener("transitionend", onEnd);
		};

		head.addEventListener("click", () => {
			if (item.classList.contains("is-open")) {
				closeFaq();
			} else {
				openFaq();
			}
		});
	});
});

// .follow-banner 表示/非表示
document.addEventListener("DOMContentLoaded", () => {
	const banner = document.querySelector(".follow-banner");
	if (!banner) return;

	const toggleBanner = () => {
		const scrollY = window.scrollY;
		const viewportH = window.innerHeight;
		const pageH = document.documentElement.scrollHeight;

		if (scrollY + viewportH >= pageH - 2) {
			banner.classList.add("is-hidden");
		} else {
			banner.classList.remove("is-hidden");
		}
	};

	window.addEventListener("scroll", toggleBanner);
	window.addEventListener("resize", toggleBanner);

	toggleBanner();
});
